// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_documents.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.ListProposalDocumentsRequest
 */ export class ListProposalDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * "" = all; solicitation|volumes|pricing|past_performance|teaming|reviews|submission|pursuit|library|other
   *
   * @generated from field: string section = 2;
   */ _define_property(this, "section", ""), /**
   * title/filename contains, case-insensitive
   *
   * @generated from field: string query = 3;
   */ _define_property(this, "query", ""), /**
   * hub_category
   *
   * @generated from field: string category = 4;
   */ _define_property(this, "category", ""), /**
   * upload|pursuit|library|sharepoint|generated
   *
   * @generated from field: string origin = 5;
   */ _define_property(this, "origin", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalDocumentsRequest, "runtime", proto3);
_define_property(ListProposalDocumentsRequest, "typeName", "mono.projectdata.v1.ListProposalDocumentsRequest");
_define_property(ListProposalDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalDocument
 */ export class ProposalDocument extends Message {
    static fromBinary(bytes, options) {
        return new ProposalDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalDocument, a, b);
    }
    constructor(data){
        super(), /**
   * "<store>:<source_id>"  (stable ?doc= key)
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string section = 2;
   */ _define_property(this, "section", ""), /**
   * attachment|volume_document|workbook|qa_file|submission|pricing_workbook|pursuit_artifact|library_reuse|sharepoint_link|review_session|pp_selection|teaming_partner
   *
   * @generated from field: string store = 3;
   */ _define_property(this, "store", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string filename = 6;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 7;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 size_bytes = 8;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * effective hub_category
   *
   * @generated from field: string category = 9;
   */ _define_property(this, "category", ""), /**
   * standard|legal_restricted (only returned to callers allowed to see it)
   *
   * @generated from field: string sensitivity = 10;
   */ _define_property(this, "sensitivity", ""), /**
   * @generated from field: string origin_kind = 11;
   */ _define_property(this, "originKind", ""), /**
   * "OMEGA Recompete (pursuit)", "Library: CPARS summary v3", "SharePoint: Contracts/…"
   *
   * @generated from field: string origin_label = 12;
   */ _define_property(this, "originLabel", ""), /**
   * in-app link, or "" for external
   *
   * @generated from field: string origin_href = 13;
   */ _define_property(this, "originHref", ""), /**
   * @generated from field: string artifact_id = 14;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string shirohige_document_id = 15;
   */ _define_property(this, "shirohigeDocumentId", ""), /**
   * @generated from field: string volume_id = 16;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string volume_document_id = 17;
   */ _define_property(this, "volumeDocumentId", ""), /**
   * @generated from field: int32 version_count = 18;
   */ _define_property(this, "versionCount", 0), /**
   * "v7", "Amendment 0003", "Final"
   *
   * @generated from field: string version_label = 19;
   */ _define_property(this, "versionLabel", ""), /**
   * RFC3339
   *
   * @generated from field: string updated_at = 20;
   */ _define_property(this, "updatedAt", ""), /**
   * @generated from field: string updated_by = 21;
   */ _define_property(this, "updatedBy", ""), /**
   * onlyoffice|workbook_editor|preview|page_viewer|download|external|in_app
   *
   * @generated from field: string open_mode = 22;
   */ _define_property(this, "openMode", ""), /**
   * @generated from field: bool in_package = 23;
   */ _define_property(this, "inPackage", false), /**
   * ""|processing|failed|unreviewed_amendment|basis|superseded
   *
   * @generated from field: string status = 24;
   */ _define_property(this, "status", ""), /**
   * @generated from field: bool can_edit = 25;
   */ _define_property(this, "canEdit", false), /**
   * @generated from field: bool can_remove = 26;
   */ _define_property(this, "canRemove", false), /**
   * @generated from field: string description = 28;
   */ _define_property(this, "description", ""), /**
   * SharePoint web_url (link rows)
   *
   * @generated from field: string external_url = 27;
   */ _define_property(this, "externalUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalDocument, "runtime", proto3);
_define_property(ProposalDocument, "typeName", "mono.projectdata.v1.ProposalDocument");
_define_property(ProposalDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "store",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "origin_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "origin_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "origin_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "version_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "open_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "in_package",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 26,
            name: "can_remove",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 28,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "external_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalDocumentSectionCount
 */ export class ProposalDocumentSectionCount extends Message {
    static fromBinary(bytes, options) {
        return new ProposalDocumentSectionCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalDocumentSectionCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalDocumentSectionCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalDocumentSectionCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section = 1;
   */ _define_property(this, "section", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalDocumentSectionCount, "runtime", proto3);
_define_property(ProposalDocumentSectionCount, "typeName", "mono.projectdata.v1.ProposalDocumentSectionCount");
_define_property(ProposalDocumentSectionCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalDocumentsResponse
 */ export class ListProposalDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * over the unfiltered, caller-visible set
   *
   * @generated from field: repeated mono.projectdata.v1.ProposalDocumentSectionCount sections = 2;
   */ _define_property(this, "sections", []), /**
   * = ProposalNavCounts.documents
   *
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * @generated from field: bool can_upload = 4;
   */ _define_property(this, "canUpload", false), /**
   * @generated from field: bool can_upload_pricing_only = 5;
   */ _define_property(this, "canUploadPricingOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalDocumentsResponse, "runtime", proto3);
_define_property(ListProposalDocumentsResponse, "typeName", "mono.projectdata.v1.ListProposalDocumentsResponse");
_define_property(ListProposalDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ProposalDocument,
            repeated: true
        },
        {
            no: 2,
            name: "sections",
            kind: "message",
            T: ProposalDocumentSectionCount,
            repeated: true
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "can_upload",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "can_upload_pricing_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProposalDocumentRequest
 */ export class UpdateProposalDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProposalDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProposalDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProposalDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProposalDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: optional string title = 3;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional string category = 4;
   */ _define_property(this, "category", void 0), /**
   * @generated from field: optional string sensitivity = 5;
   */ _define_property(this, "sensitivity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProposalDocumentRequest, "runtime", proto3);
_define_property(UpdateProposalDocumentRequest, "typeName", "mono.projectdata.v1.UpdateProposalDocumentRequest");
_define_property(UpdateProposalDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProposalDocumentResponse
 */ export class UpdateProposalDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProposalDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProposalDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProposalDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProposalDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalDocument document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProposalDocumentResponse, "runtime", proto3);
_define_property(UpdateProposalDocumentResponse, "typeName", "mono.projectdata.v1.UpdateProposalDocumentResponse");
_define_property(UpdateProposalDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: ProposalDocument
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveProposalDocumentRequest
 */ export class RemoveProposalDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveProposalDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveProposalDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveProposalDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveProposalDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveProposalDocumentRequest, "runtime", proto3);
_define_property(RemoveProposalDocumentRequest, "typeName", "mono.projectdata.v1.RemoveProposalDocumentRequest");
_define_property(RemoveProposalDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveProposalDocumentResponse
 */ export class RemoveProposalDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveProposalDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveProposalDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveProposalDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveProposalDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveProposalDocumentResponse, "runtime", proto3);
_define_property(RemoveProposalDocumentResponse, "typeName", "mono.projectdata.v1.RemoveProposalDocumentResponse");
_define_property(RemoveProposalDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.BringPursuitDocumentsIntoProposalRequest
 */ export class BringPursuitDocumentsIntoProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new BringPursuitDocumentsIntoProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BringPursuitDocumentsIntoProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BringPursuitDocumentsIntoProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BringPursuitDocumentsIntoProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated string artifact_ids = 2;
   */ _define_property(this, "artifactIds", []), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BringPursuitDocumentsIntoProposalRequest, "runtime", proto3);
_define_property(BringPursuitDocumentsIntoProposalRequest, "typeName", "mono.projectdata.v1.BringPursuitDocumentsIntoProposalRequest");
_define_property(BringPursuitDocumentsIntoProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.BringPursuitDocumentsIntoProposalResponse
 */ export class BringPursuitDocumentsIntoProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new BringPursuitDocumentsIntoProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BringPursuitDocumentsIntoProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BringPursuitDocumentsIntoProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BringPursuitDocumentsIntoProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalDocument documents = 1;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BringPursuitDocumentsIntoProposalResponse, "runtime", proto3);
_define_property(BringPursuitDocumentsIntoProposalResponse, "typeName", "mono.projectdata.v1.BringPursuitDocumentsIntoProposalResponse");
_define_property(BringPursuitDocumentsIntoProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ProposalDocument,
            repeated: true
        }
    ]));
